import { LocalizedShortMonthYearFromUtc, SpacedDash } from '@mews-commander/ui';

interface TimeUnitCountsLabelProps {
    startUtc: string | undefined;
    endUtc: string | undefined;
}

const TimeUnitCountLabel = ({ startUtc, endUtc }: TimeUnitCountsLabelProps) => {
    if (!startUtc || !endUtc) {
        return null;
    }

    return (
        <>
            <LocalizedShortMonthYearFromUtc utcString={startUtc} />
            {SpacedDash}
            <LocalizedShortMonthYearFromUtc utcString={endUtc} />
        </>
    );
};

export default TimeUnitCountLabel;
